import { css } from 'styled-components';
import {
  grid, gridUnit, getSpacing, SpacingName, getTypography, TypographyName, BreakpointQueryName, ThemedFunctor,
} from '@doveit/lego';

export const contentStyle: ThemedFunctor = ({ theme }) => css`
  ${grid(theme, { gutter: SpacingName.SMALL })}
  ${getSpacing.marginTop(theme, SpacingName.BIG)}
`;

export const stepsStyle: ThemedFunctor = ({ theme }) => css`
  ${gridUnit(theme, { gutter: SpacingName.SMALL, size: { MD: 1 / 2 } })}
`;

export const pictureStyle: ThemedFunctor = ({ theme }) => css`
  display: none;
  ${gridUnit(theme, { gutter: SpacingName.SMALL, size: { MD: 1 / 2 } })}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    display: block;
  }

  img {
    width: 100%;
  }
`;

export const stepStyle: ThemedFunctor = ({ theme }) => css`
  ${getSpacing.paddingBottom(theme, SpacingName.MEDIUM)}
  position: relative;
  margin-left: 1rem;
  padding-left: 1.5rem;
  border-left: 3px solid transparent;

  &:last-child {
    padding-bottom: 0;
    border-color: transparent;
  }

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    border-left-color: ${theme.palettes.neutrals.light};
    margin-left: 1.4rem;
    padding-left: 2.7rem;
  }
`;

export const stepNumberStyle: ThemedFunctor = ({ theme, $last }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  font-weight: bold;
  background-color: ${theme.palettes.neutrals.lighter};
  width: 1.9rem;
  height: 1.9rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: ${theme.palettes.brand.primary};
  border: 2px solid ${theme.palettes.brand.primary};
  border-radius: 50%;
  ${getSpacing.marginBottom(theme, SpacingName.SMALL)}
  position: absolute;
  left: -2px;
  top: -4px;
  transform: translateX(-50%);

  ${$last ? `
    background-color: ${theme.palettes.brand.primary};
    border-color: ${theme.palettes.brand.primary};
    color: ${theme.palettes.neutrals.lightest};
  ` : ''}

  ${theme.breakpoints.up(BreakpointQueryName.MD)} {
    width: 2.75rem;
    height: 2.75rem;
    top: 0;
  }
`;

export const stepTitleStyle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const stepDescriptionStyle: ThemedFunctor = ({ theme }) => css`
  ${getTypography(theme, TypographyName.BODY)}
  ${getSpacing.marginTop(theme, SpacingName.SMALLEST)}
`;
